// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { IEventTelemetry } from '@microsoft/applicationinsights-web';
import CorrelationVector from './../../../lib/CorrelationVector';

// The custom event names show up in the App Insights user flow diagrams. That's why the action is used as the name.
/**
 * Logs page action events to App Insights. 
 * @param action Action taken by user. Include control text, type and action so it's easier to identify.
 * EX: 'Submit order: Create Order button clicked', View or Print packaging instructions link clicked.
 */
export function createPageAction(action: string, info: any = {}): IEventTelemetry {
    return {
        name: action,
        properties: {
            correlationVector: CorrelationVector.getCurrentValue(),
            data: info,
            type: 'Page Action',
        },
    } as IEventTelemetry;
}
